module.exports = "<div>\n  <router-outlet></router-outlet>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 354
// module chunks = 1